const faqData = [
  {
    q: '吃瓜网51是什么类型的平台？',
    a: '吃瓜网51是一个综合性的娱乐八卦与热点话题讨论社区。用户可以在平台上浏览最新的明星八卦、影视综艺资讯、社会热点事件讨论，也可以自主发帖分享身边的趣闻轶事和独家爆料。',
  },
  {
    q: '如何参与话题讨论？',
    a: '你只需注册一个吃瓜网51账号，即可在任意话题圈内发帖、评论和互动。我们支持文字、图片等多种内容形式，让你自由表达观点。邀请好友一起加入讨论，体验更佳。',
  },
  {
    q: '平台对爆料内容有什么审核标准？',
    a: '我们鼓励用户分享真实、有价值的资讯内容。平台采用人工+智能双重审核机制，对涉及他人隐私、恶意造谣、违法违规的内容进行严格管控，维护健康积极的社区环境。',
  },
  {
    q: '吃瓜网51移动端有什么特色功能？',
    a: '移动客户端支持实时推送热门话题和最新爆料通知，让你第一时间掌握最热八卦。还支持夜间模式、离线缓存、语音发帖等便捷功能，随时随地畅快吃瓜。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-secondary-100">
            <i className="ri-question-answer-line text-secondary-500 text-lg"></i>
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">常见问答</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 pl-11 md:pl-12">关于吃瓜网51，你可能想了解的问题</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {faqData.map((item, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70"
            >
              <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 mb-3 flex items-start gap-2">
                <span className="text-primary-500 mt-0.5 shrink-0">
                  <i className="ri-question-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}